var _circle, _path, _g, _g2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSad2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sad-2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_811",
    "data-name": "Ellipse 811",
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#ffd93b"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_37791",
    "data-name": "Path 37791",
    d: "M110.073,80.073A30,30,0,0,1,56.72,98.907,30,30,0,0,0,98.907,56.72,29.968,29.968,0,0,1,110.073,80.073Z",
    transform: "translate(-50.073 -50.073)",
    fill: "#f4c534"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15435",
    "data-name": "Group 15435",
    transform: "translate(12.371 27.304)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37792",
    "data-name": "Path 37792",
    d: "M119.1,234.816c0,3.2-3.032,5.788-6.765,5.788s-6.765-2.587-6.765-5.788a4.661,4.661,0,0,1,.356-1.824c.885,2.475,3.424,3.321,6.409,3.321s5.526-.846,6.409-3.321A4.7,4.7,0,0,1,119.1,234.816Z",
    transform: "translate(-105.568 -232.992)",
    fill: "#3e4347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37793",
    "data-name": "Path 37793",
    d: "M290.976,234.816c0,3.2,3.032,5.788,6.765,5.788s6.765-2.587,6.765-5.788a4.661,4.661,0,0,0-.356-1.824c-.885,2.475-3.424,3.321-6.409,3.321s-5.526-.846-6.409-3.321A4.7,4.7,0,0,0,290.976,234.816Z",
    transform: "translate(-269.249 -232.992)",
    fill: "#3e4347"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15436",
    "data-name": "Group 15436",
    transform: "translate(14.745 17.52)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37794",
    "data-name": "Path 37794",
    d: "M306.58,157.5c-4.759-.979-7.551-2.983-8.786-6.311a1.25,1.25,0,1,1,2.344-.87c.617,1.665,1.965,3.707,6.945,4.731a1.251,1.251,0,0,1-.5,2.451Z",
    transform: "translate(-277.572 -149.508)",
    fill: "#e9b02c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37795",
    "data-name": "Path 37795",
    d: "M125.835,156.454a1.249,1.249,0,0,1,1.089-1.391c3.441-.418,5.871-2.092,6.844-4.714a1.25,1.25,0,1,1,2.344.87c-1.3,3.491-4.534,5.8-8.884,6.326A1.254,1.254,0,0,1,125.835,156.454Z",
    transform: "translate(-125.826 -149.53)",
    fill: "#e9b02c"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37796",
    "data-name": "Path 37796",
    d: "M181.572,343.37a25.868,25.868,0,0,0-19.571,0c-1.016.369-1.841-1.014-1.142-1.918,3.1-4.057,6.984-6.364,10.92-6.364s7.841,2.306,10.92,6.364C183.4,342.355,182.571,343.737,181.572,343.37Z",
    transform: "translate(-141.779 -295.82)",
    fill: "#3e4347"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSad2);
export default __webpack_public_path__ + "static/media/sad-2.731a2e4793edc8802c785bcc2762a822.svg";
export { ForwardRef as ReactComponent };